import { RichTextBlock } from 'prismic-reactjs'
import React from 'react'
import { resolvePrismicLink } from '../../../utils/prismicLinkResolver'
import usePageContext from '../../../hooks/usePageContext'
import PromotionsSection from '../../sections/PromotionsSection'
import { PromotionsSliceProps } from './types'
import { mapButtonProps } from '../../atoms/Button/utils'

const PromotionsSlice: React.FC<PromotionsSliceProps> = ({ slice }) => {
  const { primary, items = [] } = slice
  const { p_title, p_is_main_heading, p_subtitle, p_description } = primary || {}

  const { group } = usePageContext()

  return (
    <PromotionsSection
      heading={p_title?.text}
      isMainHeading={p_is_main_heading}
      subheading={p_subtitle?.text}
      description={p_description?.html}
      isHeadingGreen
      inner="inners.primary"
      paddingTop={['38px', '', '90px']}
      paddingBottom={['50px', '', '30px']}
      headingPadding={['60px', '', '80px']}
      data={items.map((item, index) => {
        const {
          p_item_image,
          p_item_title,
          p_item_subtitle,
          p_item_description,
          p_item_features_title,
          p_item_features,
          p_link,
          p_link_text,
          p_button_text,
          p_button_type,
          p_button_link,
          p_button_is_centered,
          p_button_caption,
          p_button_caption_mobile_size,
          p_button_caption_desktop_size
        } = item || {}

        return {
          key: `promotion-box-${index}`,
          image: p_item_image?.url
            ? {
                publicURL: p_item_image.url,
                childImageSharp: p_item_image && {
                  gatsbyImageData: p_item_image.gatsbyImageData
                },
                width: p_item_image?.dimensions?.width,
                height: p_item_image?.dimensions?.height,
                alt: p_item_image.alt
              }
            : undefined,
          title: p_item_title,
          subtitle: p_item_subtitle,
          description: p_item_description,
          list: {
            head: p_item_features_title,
            body: (p_item_features?.raw || []).map((feature: RichTextBlock, index) => ({
              key: `list-item-${index}`,
              value: feature?.text || ''
            }))
          },
          pdf: {
            url: p_link?.url,
            urlText: p_link_text
          },
          cta: mapButtonProps(
            p_button_type,
            p_button_text,
            resolvePrismicLink(p_button_link, group),
            p_button_link?.link_type,
            p_button_caption,
            p_button_caption_mobile_size,
            p_button_caption_desktop_size,
            p_button_is_centered
          )
        }
      })}
    />
  )
}

export default PromotionsSlice
